var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.editable
        ? _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailInfo",
                  attrs: { title: "LBL0003715" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable &&
                          _vm.popupParam.noPlan === "Y" &&
                          !_vm.updateMode &&
                          !_vm.disabled
                            ? _c("c-btn", {
                                attrs: { label: "LBLSELECT", icon: "add" },
                                on: { btnClicked: _vm.add },
                              })
                            : _vm._e(),
                          _vm.editable && _vm.updateMode && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "LBLCOMPLETE",
                                  icon: "save",
                                  color: "blue",
                                },
                                on: { btnClicked: _vm.resultComplete },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.result,
                                  mappingType: _vm.saveType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveInspection,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _vm.editable && !_vm.result.equipmentCd
                      ? _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-label-text", {
                              attrs: { title: "LBL0003716" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.editable && _vm.result.plantName
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3",
                          },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "LBLPLANT",
                                value: _vm.result.plantName,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.editable && _vm.result.equipmentTypeCd
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3",
                          },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "LBL0000633",
                                value: _vm.result.equipmentTypeName,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.editable && _vm.result.equipmentCd
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3",
                          },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "LBL0003705",
                                value: _vm.result.equipmentCd,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.editable && _vm.result.equipmentName
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3",
                          },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "LBL0000632",
                                value: _vm.result.equipmentName,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.editable && _vm.result.recentMaintainDate
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-3",
                          },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "LBL0003782",
                                value: _vm.result.recentMaintainDate,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.editable && _vm.result.relatedLawsName
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-6 col-lg-6",
                          },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "LBL0003610",
                                value: _vm.result.relatedLawsName,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "col-12" }),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0003783", bgClass: "" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            label: "LBL0003618",
                            codeGroupCd: "MDM_MAINTENANCE_KIND_CD",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                          },
                          model: {
                            value: _vm.result.equipmentCheckTypeCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "equipmentCheckTypeCd", $$v)
                            },
                            expression: "result.equipmentCheckTypeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            disabled: _vm.disabled,
                            label: "LBL0003615",
                            name: "maintenanceUserId",
                            type: "user",
                          },
                          model: {
                            value: _vm.result.maintenanceUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "maintenanceUserId", $$v)
                            },
                            expression: "result.maintenanceUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "LBL0003762",
                            name: "maintenanceDate",
                          },
                          model: {
                            value: _vm.result.maintenanceDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "maintenanceDate", $$v)
                            },
                            expression: "result.maintenanceDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            codeGroupCd: "MIM_CHECK_RESULT_CD",
                            type: "edit",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "inspResultAfterMemCd",
                            label: "LBL0003763",
                          },
                          model: {
                            value: _vm.result.inspResultAfterMemCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "inspResultAfterMemCd", $$v)
                            },
                            expression: "result.inspResultAfterMemCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "LBL0003764",
                            range: true,
                            minuteStep: 10,
                            type: "time",
                            name: "maintenanceTimeList",
                          },
                          model: {
                            value: _vm.maintenanceTimeList,
                            callback: function ($$v) {
                              _vm.maintenanceTimeList = $$v
                            },
                            expression: "maintenanceTimeList",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "LBL0003776",
                            range: true,
                            minuteStep: 10,
                            type: "time",
                            name: "stopDrivingTimeList",
                          },
                          model: {
                            value: _vm.stopDrivingTimeList,
                            callback: function ($$v) {
                              _vm.stopDrivingTimeList = $$v
                            },
                            expression: "stopDrivingTimeList",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c(
                          "c-field",
                          {
                            attrs: {
                              disabled: _vm.disabled,
                              label: "LBL0003784",
                              name: "memDeptEntrantUserId",
                              type: "user",
                            },
                            model: {
                              value: _vm.result.memDeptEntrantUserId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.result,
                                  "memDeptEntrantUserId",
                                  $$v
                                )
                              },
                              expression: "result.memDeptEntrantUserId",
                            },
                          },
                          [_vm._v(" >")]
                        ),
                      ],
                      1
                    ),
                    _vm.editable
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                          },
                          [
                            _c("c-moc", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: _vm.disabled,
                                label: "LBLMOCNO",
                                name: "sopMocId",
                              },
                              model: {
                                value: _vm.result.sopMocId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.result, "sopMocId", $$v)
                                },
                                expression: "result.sopMocId",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "LBL0003766",
                            name: "maintenanceQualifications",
                          },
                          model: {
                            value: _vm.result.maintenanceQualifications,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.result,
                                "maintenanceQualifications",
                                $$v
                              )
                            },
                            expression: "result.maintenanceQualifications",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "LBL0003767",
                            rows: 2,
                            name: "maintenanceCause",
                          },
                          model: {
                            value: _vm.result.maintenanceCause,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "maintenanceCause", $$v)
                            },
                            expression: "result.maintenanceCause",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "LBL0003768",
                            rows: 2,
                            name: "maintenanceContent",
                          },
                          model: {
                            value: _vm.result.maintenanceContent,
                            callback: function ($$v) {
                              _vm.$set(_vm.result, "maintenanceContent", $$v)
                            },
                            expression: "result.maintenanceContent",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "LBL0003769",
                            rows: 2,
                            name: "maintenanceResultSummary",
                          },
                          model: {
                            value: _vm.result.maintenanceResultSummary,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.result,
                                "maintenanceResultSummary",
                                $$v
                              )
                            },
                            expression: "result.maintenanceResultSummary",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "LBL0003770",
                            rows: 2,
                            name: "reviewOpinionOfMananger",
                          },
                          model: {
                            value: _vm.result.reviewOpinionOfMananger,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.result,
                                "reviewOpinionOfMananger",
                                $$v
                              )
                            },
                            expression: "result.reviewOpinionOfMananger",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }